import { useTextInput } from '@hooks';
import {
  isEmailVerified,
  signInWithEmail,
  useFirebaseAuthUserContext,
} from '@libraries/firebase';
import { Button, FormError, FormRow, getResetRoute, TextInput } from '@shared';
import { getRedirectPath } from '@utils';
import { useRouter } from 'next/dist/client/router';
import { FormEvent, useState } from 'react';
import { FacebookButton } from '../components/FacebookButton';
import { FacebookSeparator } from '../components/FacebookSeparator';
import { ForgotPassword } from '../components/ForgotPassword';
import { AuthForm } from '../components/Form';
import { AuthHeading } from '../components/Heading';
import { SignUpSignInText } from '../components/SignUpSignInText';

export function LoginForm() {
  const [isAuthenticating, setAuthenticating] = useState(false);
  const { user } = useFirebaseAuthUserContext();
  const email = useTextInput();
  const password = useTextInput();
  const router = useRouter();
  const redirectTo = getRedirectPath(router);
  const resetRoute = getResetRoute(redirectTo);

  function handleError(newEmailErr: string, newPasswordErr?: string) {
    setAuthenticating(() => false);

    if (newEmailErr) {
      email.updateError(newEmailErr);
      password.updateError('');
    }

    if (newPasswordErr) {
      email.updateError('');
      password.updateError(newPasswordErr);
    }
  }

  function handleSignedIn() {
    setAuthenticating(() => false);

    if (isEmailVerified(user)) {
      router.push(redirectTo);
    }
  }

  function handleSignIn(event?: FormEvent) {
    event?.preventDefault();

    email.updateError('');
    password.updateError('');
    setAuthenticating(() => true);
    signInWithEmail(email.value, password.value, handleError, handleSignedIn);
  }

  return (
    <AuthForm onSubmit={handleSignIn}>
      <AuthHeading>Welcome Back!</AuthHeading>

      <FormRow>
        <TextInput
          disabled={isAuthenticating}
          hasError={!!email.error}
          onChange={email.updateValue}
          placeholder="Email"
          type="email"
          value={email.value}
        />
        <FormError msg={email.error} />
      </FormRow>

      <FormRow>
        <TextInput
          disabled={isAuthenticating}
          hasError={!!password.error}
          onChange={password.updateValue}
          placeholder="Password"
          type="password"
          value={password.value}
        />
        <FormError msg={password.error} />
      </FormRow>

      <ForgotPassword href={resetRoute} text="Forgot password?" />

      <Button onClick={handleSignIn}>Sign in</Button>

      <FacebookSeparator />

      <FacebookButton text="Sign in" />

      <SignUpSignInText hasAccount={false} redirectTo={redirectTo} />
    </AuthForm>
  );
}
